import { useEffect, useState } from "react";
import { fetchTehsils, downloadTehsilsExcel } from "../Api/ViewTehsilMaster";
import { Container, Table, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";

const ViewTehsilMaster = () => {
  const [tehsils, setTehsils] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadTehsils = async () => {
      try {
        const data = await fetchTehsils();
        setTehsils(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Tehsils`);
      }
    };

    loadTehsils();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadTehsilsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Tehsils_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Tehsils data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div>
          <Container className="list-container">
            <div className="header-background">
              <h2 className="header-list-title">View Tehsils</h2>
              <Button className="gradient-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || tehsils.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {tehsils.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tehsil ID</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Country</th>
                    <th>Region</th>
                    <th>District</th>
                    <th>Created On</th>
                    <th>Created By</th>
                    <th>Changed On</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {tehsils.map((tehsil, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{tehsil.tehsil_ID}</td>
                      <td>{tehsil.code}</td>
                      <td>{tehsil.description}</td>
                      <td>{tehsil.country}</td>
                      <td>{tehsil.region}</td>
                      <td>{tehsil.district}</td>
                      <td>
                        {moment(tehsil.createdOnDate).format('L')} at {tehsil.createdOnTime?.substring(0, 8)}
                      </td>
                      <td>{tehsil.createdBy}</td>
                      <td>
                        {tehsil.changedOnDate ? 
                          `${moment(tehsil.changedOnDate).format('L')} at ${tehsil.changedOnTime?.substring(0, 8)}` 
                          : 'N/A'}
                      </td>
                      <td>{tehsil.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No tehsils found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewTehsilMaster;